// extracted by mini-css-extract-plugin
module.exports = {"component":"scroll-to-top_component__UNvrS"};